<template>
  <layout :drawer="false">

    <template slot="nav">
      <v-tabs>
        <v-tab>Viewers Map check</v-tab>
      </v-tabs>
    </template>

    <template slot="content">
        <v-container fluid>
          <v-card fluid>
            <ViewersMapChecker />
          </v-card>
        </v-container>
    </template>
  </layout>
</template>

<script>
import Layout from "@/views/Layout.vue";
import ViewersMapChecker from "@/components/commons/ViewersMapChecker.vue";


export default {
  name: "ViewersMapCheckerView",
  components: {
    ViewersMapChecker,
    Layout
  },
}
</script>